import React from 'react';
import { motion } from 'framer-motion';
import { CompassIcon, WrenchIcon, WalletIcon, PackageXIcon, YoutubeIcon, ClockIcon, LineChartIcon, CalendarXIcon } from 'lucide-react';
const pains = [{
  icon: CompassIcon,
  title: 'No sabés por dónde empezar',
  desc: 'Sin hoja de ruta clara, dás vueltas en círculos sin avanzar.'
}, {
  icon: WrenchIcon,
  title: 'Herramientas que te abruman',
  desc: 'Shopify, Pixel, Meta Ads... no sabés cómo conectar todo junto.'
}, {
  icon: WalletIcon,
  title: 'Miedo a gastar mal',
  desc: 'No querés invertir en ads sin saber si tu tienda está bien configurada.'
}, {
  icon: PackageXIcon,
  title: 'Sin productos para vender',
  desc: 'No tenés idea qué producto digital funciona realmente en el mercado.'
}, {
  icon: YoutubeIcon,
  title: 'Info suelta por todos lados',
  desc: 'Tutoriales contradictorios sin un sistema probado detrás.'
}, {
  icon: ClockIcon,
  title: 'Semanas sin resultados',
  desc: 'Configurás cosas, tocás botones, pero nunca llegás a vender nada.'
}, {
  icon: LineChartIcon,
  title: 'Sin saber si tus ads funcionan',
  desc: 'Gastás en publicidad sin entender qué estás testeando ni por qué.'
}, {
  icon: CalendarXIcon,
  title: 'Fin de mes igual que el principio',
  desc: 'Sin estructura clara, no hay progreso medible ni ventas reales.'
}];
export function PainPoints() {
  return <section className="py-12 md:py-20 relative" data-id="element-180">
      <div className="container mx-auto px-4" data-id="element-181">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-182">
          <h2 className="text-gold-500 font-display text-base md:text-2xl tracking-widest uppercase mb-2 md:mb-3" data-id="element-183">
            ¿Te pasa esto?
          </h2>
          <p className="text-xl md:text-4xl font-medium text-white" data-id="element-184">
            Si querés arrancar en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5" data-id="element-185">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} whileHover={{
          scale: 1.03,
          borderColor: 'rgba(212,175,55,0.3)'
        }} className="bg-dark-800 p-4 md:p-5 rounded-lg border border-white/5 cursor-default" data-id="element-186">
              <div className="w-9 h-9 md:w-11 md:h-11 bg-dark-900 rounded-full flex items-center justify-center mb-3 border-gold-subtle" data-id="element-187">
                <pain.icon className="text-gold-500 w-4 h-4 md:w-5 md:h-5" data-id="element-188" />
              </div>
              <h3 className="text-white font-bold text-sm md:text-base mb-1.5 leading-tight" data-id="element-189">
                {pain.title}
              </h3>
              <p className="text-gray-400 text-xs md:text-sm leading-snug" data-id="element-190">
                {pain.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-8 md:mt-12 text-center" data-id="element-191">
          <p className="text-lg md:text-2xl font-display text-white tracking-wide uppercase leading-tight px-4" data-id="element-192">
            ¿Cuántas semanas más vas a dar vueltas{' '}
            <span className="text-gold-500" data-id="element-193">
              sin tener tu negocio funcionando?
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}